<template>
	<div class="qrcode">
		<!-- 客 服 微 信 弹 窗   -->
		<el-dialog :title="$t('other.a3')" :visible.sync="customerDiaCopy" :modal="false"  @close="$emit('update:customerDia',false)" width="30%">
			<div class="owklgg">
				<div class="okgjbkd" v-if="!hideOverSea">
					<div class="appimg">
						<img style="width:100%" src="../../assets/img/overSea.jpg" />
					</div>
					<div class="tesxt"><span>{{$t('other.a4')}}</span></div>
				</div>
				<div class="okgjbkd">
					<div class="appimg">
						<img style="width:100%" src="../../assets/img/kefu_04.jpg" />
					</div>
					<div class="tesxt"><span>{{distributeText}}</span></div>
					
				</div>
			</div>
			
			
			<span slot="footer" class="dialog-footer">
				
				<div>
					<el-button type="primary" @click="customerDiaCopy=false">{{$t('other.a5')}} </el-button>
				</div>
			</span>
		</el-dialog>
		<!-- 店小生数据分板插件 -->
		<el-dialog :title="$t('other.a153')" :visible.sync="weanlyCopy" :modal="false"  @close="$emit('update:weanly',false)" width="30%">
			<div class="owklgg">
				<a style="color:#fff" href="https://file.shopsbu.com/crx/extension1.6.3.crx">
				
				<el-button style="font-size:18px;" type="primary">{{$t('other.a6')}} <i class="el-icon-upload el-icon--right"></i></el-button>
				</a>
			</div>
			
			<span slot="footer" class="dialog-footer">

				<div style="text-align:left;padding-bottom:10px;color:red">{{$t('other.a7')}}</div>
				<div style="font-size:14px;text-align:left;margin-bottom:10px">
					<p style="margin-bottom:10px;">{{$t('other.a8')}}</p>
					<p style="margin-bottom:10px;">{{$t('other.a9')}}</p>
					<p style="margin-bottom:10px;">{{$t('other.a10')}}</p>
					<p style="color:red">{{$t('other.a11')}}</p>
					<div class="ginkf" @click="goToDesc()">
						{{$t('other.a12')}}
					</div>
				</div>

				<div style="text-align:left;padding-bottom:10px;color:red">{{$t('other.a13')}}</div>
				<div style="font-size:14px;text-align:left;margin-bottom:10px">
					<p style="margin-bottom:10px;">{{$t('other.a14')}}</p>
					<p style="margin-bottom:10px;">{{$t('other.a15')}}</p>
					<p style="margin-bottom:10px;">{{$t('other.a16')}}<a href="https://chrome.google.com/webstore/detail/%E8%99%BE%E7%9A%AE%E8%B4%9D%E5%88%86%E6%9E%90/gacfggacdlboibfpfajebpbncipchhma/related" target="_blank">{{$t('other.a17')}}</a>{{$t('other.a18')}} </p>
					<p></p>
				</div>
				<div>
					<el-button type="primary" @click="weanlyCopy=false">{{$t('other.a5')}} </el-button>
				</div>
			</span>
		</el-dialog>

		<!-- 扫码下载安卓/IOS移动端应用 -->
		<el-dialog :title="$t('other.a3305')" :visible.sync="showAppDiaCopy" :modal="false"  @close="$emit('update:showAppDia',false)" width="50%">
			<div class="owklgg">
				<!-- <div class="okgjbkd">
					<div class="appimg">
						<img style="width:100%" src="https://i.shopsbu.com/static/picture/scan.png" />
					</div>
					<div class="tesxt"><span>{{$t('other.a20')}}</span></div>
				</div> -->
				<!-- <div class="okgjbkd">
					<div class="appimg">
						<img style="width:100%" src="https://i.shopsbu.com/static/picture/apple.png" />
					</div>
					<div class="tesxt"><span>{{$t('other.a704')}}(IOS)</span></div>
				</div> -->
				<div class="okgjbkd">
					<div class="appimg">
						<img style="width:100%" src="http://i.shopsbu.com/static/picture/scan.png" />
					</div>
					<div class="tesxt"><span>{{$t('other.a3306')}}</span></div>
				</div>
				<div class="okgjbkd">
					<div class="appimg">
						<img style="width:100%" src="https://xianggangerp.oss-cn-hongkong.aliyuncs.com/customer-service/store-app.jpg" />
					</div>
					<div class="tesxt"><span>{{$t('other.a21')}}</span></div>
				</div>
			</div>
			
			<span slot="footer" class="dialog-footer">
				<div style="text-align:left;padding-bottom:10px;color:red">{{$t('other.a22')}}</div>
				<div style="font-size:14px;text-align:left;margin-bottom:10px">
					<p style="padding-bottom:10px;color:#F56C6C;">{{$t('other.a2854')}}</p>
					<!-- <p style="color:#409EFF">{{$t('other.a24')}}</p> -->
				</div>
				<div>
					<el-button type="primary" @click="showAppDiaCopy=false">{{$t('other.a5')}} </el-button>
				</div>
			</span>
		</el-dialog>


		<!-- 查看打印历史纪录 -->
		<el-dialog :title="$t('other.a25')" :visible.sync="In_stockDialog" @close="$emit('update:instockdia',false)" width="50%">
			<div style="width: 100%;">
				<el-input size="mini" style="width: 180px;" value="number" :placeholder="$t('other.a26')" v-model="searchtext" clearable>
				</el-input>
				<el-button style="margin-left: 10px;" size="mini" type="primary" @click="setPeriod">{{$t('other.a27')}}</el-button>
				<el-button style="margin-left: 10px;" size="mini" type="primary" @click="printTogether">{{$t('other.a28')}}</el-button>
				<el-table :data="printhistory" height="400px" @selection-change="handleSelectionChange">
					<el-table-column :label="$t('other.a29')" type="selection" width="55">
					</el-table-column>
					<el-table-column :label="$t('other.a30')">
						<template slot-scope="props">
							<span>{{props.row.logistics}}-{{props.row.tip[1]}}{{props.row.tip[2]}}-{{props.row.ordersn.length}}</span>
						</template>
					</el-table-column>
					<el-table-column :label="$t('other.a31')">
						<template slot-scope="props">
							<span>{{getTime(props.row.updateTime)}}</span>
						</template>

					</el-table-column>
					<el-table-column :label="$t('other.a32')" :show-overflow-tooltip="true">
						<template slot-scope="props">
							<span>{{props.row.printfTimes}}</span>
						</template>
					</el-table-column>
					<el-table-column :show-overflow-tooltip="true" :label="$t('other.a33')">
						<template slot-scope="props">
							<span style="cursor: pointer;color:#409EFF ;" @click="openHistory(props.row.urls[0])">{{$t('other.a34')}}</span>
						</template>

					</el-table-column>

				</el-table>
			</div>
			<span slot="footer" class="dialog-footer">
				<div class="block">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage4"
					 :page-sizes="[15, 20, 30, 50]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="printhistorycount01">
					</el-pagination>
				</div>
				<el-button type="primary" @click="In_stockDialog=false">{{$t('other.a5')}} </el-button>
			</span>
		</el-dialog>

		<!-- 	新增运单号 -->
		<el-dialog :title="$t('other.a35')" :visible.sync="trackingDialog" @close="$emit('update:tracking_Dialog',false)" width="30%">
			<div>
				{{$t('other.a36')}}
				<div style="display: flex;align-items: center; margin-top: 10px;" v-for="(item,index) in addInputPop" :key=item.id>
					<el-input  :placeholder="$t('other.a37')" v-model="item.value" clearable></el-input>
					<div style="width: 40px;height: 38px;
					border: 1px solid #eee;text-align: center;
					border-color: #67C23A;
					margin-left: 10px;
					border-radius: 3px;
					color: #67C23A;
					cursor: pointer;
					line-height: 38px;font-size: 28px;" 
					@click="addInputDia(index)">
					<span v-show="item.id == 1">+</span>
					<span v-show="item.id !== 1">-</span>
					</div>
				</div>
				
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="trackingDialog=false">{{$t('other.a5')}} </el-button>
				<el-button type="primary" @click="confrim">{{$t('other.a38')}} </el-button>
			</span>
		</el-dialog>


		<!-- 	验收代打包货物 -->
		<el-dialog :title="$t('other.a39')" :visible.sync="Acceptance" @close="$emit('update:Acceptance_dialoag',false)" width="30%">
			<div>
				<div style="margin-bottom: 20px;width: 300px;">
					{{$t('other.a40')}} 
				</div>
				<el-select style="width: 273px;" v-model="value2" :placeholder="$t('other.a41')">
					<el-option v-for="item in AcceptancePackagedList" :key="item.trackingCode" :label="item.trackingCode" :value="item.trackingCode">
					</el-option>
				</el-select>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="Acceptance=false">{{$t('other.a5')}} </el-button>
				<el-button type="primary" @click="confrim01">{{$t('other.a38')}} </el-button>
			</span>
		</el-dialog>
		<!-- 充值明细	 -->
		<el-dialog :title="$t('other.a42')" :visible.sync="billviscopy" @close="$emit('update:billvis',false)" width="70%">
			<div style="width: 100%;">
				<div>
					<div style="padding-bottom: 10px;">
						<el-switch style="margin-right: 20px;" v-model="value3" @change="searchOrder" :active-text="$t('other.a43')" :inactive-text="$t('other.a44')">
						</el-switch>
						<el-date-picker v-model="searchTime" type="daterange" size="mini" align="right" unlink-panels :range-separator="$t('other.a47')"
						 :start-placeholder="$t('other.a45')" :end-placeholder="$t('other.a46')" @change="searchOrder" :picker-options="pickerOptions2">
						</el-date-picker>
					</div>
					<div style="padding-bottom: 10px;">

						<!-- <el-button size="mini" type="primary" @click="searchOrder">{{$t('other.a916')}}</el-button> -->
					</div>
					<div style="width: 100%;display: flex;align-items: center;">
						<span> {{$t('other.a48')}}</span>
						<el-select style="width: 150px;margin-right:15px" size="mini" @change="searchOrder" v-model="platform"
						 :placeholder="$t('other.a50')">
							<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
						<span> {{$t('other.a49')}}</span>
						<el-select style="width: 150px;margin-right:15px" size="mini" @change="searchOrder" v-model="payorderstatus"
						 :placeholder="$t('other.a50')">
							<el-option v-for="item in option01" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
						<span> {{$t('other.a51')}}</span>
						<el-select style="width: 150px;margin-right:15px" size="mini" @change="searchOrder" v-model="sortTime"
						 :placeholder="$t('other.a50')">
							<el-option v-for="item in options03" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</div>
				</div>
				<div>
					<el-table :data="payorderlist" height="400px" style="width: 100%">
						<el-table-column prop="outTradeNo" :label="$t('other.a53')" width="180">
						</el-table-column>
						<el-table-column :label="$t('other.a54')" width="180">
							<template slot-scope="props">
								<span>{{props.row.totalFee}}</span>
							</template>
						</el-table-column>

						<el-table-column :label="$t('other.a55')">
							<template slot-scope="props">
								<span>{{getStatus(props.row.orderStatus)}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="platform" :label="$t('other.a56')">
							<template slot-scope="props">
								<span>{{payMethod(props.row.platform)}}</span>
							</template>
						</el-table-column>
						<el-table-column :label="$t('other.a57')">
							<template slot-scope="props">
								<span>{{getTime(props.row.gmtCreate)}}</span>
							</template>
						</el-table-column>
					</el-table>
					<div style="width: 100%;display: flex;justify-content: flex-end;">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage4"
						 :page-sizes="[15, 30, 50, 100]" :page-size="15" layout="total, sizes, prev, pager, next, jumper" :total="payordercount">
						</el-pagination>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="billviscopy=false">{{$t('other.a5')}} </el-button>

			</span>
		</el-dialog>

		<!-- 积分扣减明细明细-->
		<el-dialog :title="$t('other.a58')" :visible.sync="intergralPop" @close="$emit('update:intergralDia',false)" width="70%">
			<div style="width: 100%;">
				<div>
					<div style="padding-bottom: 10px;">
						<!-- <el-switch style="margin-right: 20px;" v-model="value3" @change="searchOrder" active-text="按交易时间查找" inactive-text="按支付时间查找">
						</el-switch> -->
						<el-date-picker v-model="searchTime" type="daterange" size="mini" align="right" unlink-panels :range-separator="$t('other.a47')"
						 :start-placeholder="$t('other.a45')" :end-placeholder="$t('other.a46')" @change="searchOrder" :picker-options="pickerOptions2">
						</el-date-picker>
					</div>
					<div style="padding-bottom: 10px;">
					</div>
					<!-- <div style="width: 100%;display: flex;align-items: center;">
						<span> {{$t('other.a48')}}</span>
						<el-select style="width: 150px;margin-right:15px" size="mini" @change="searchOrder" v-model="platform"
						 :placeholder="$t('other.a50')">
							<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
						<span> {{$t('other.a49')}}</span>
						<el-select style="width: 150px;margin-right:15px" size="mini" @change="searchOrder" v-model="payorderstatus"
						 :placeholder="$t('other.a50')">
							<el-option v-for="item in option01" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
						<span> {{$t('other.a51')}}</span>
						<el-select style="width: 150px;margin-right:15px" size="mini" @change="searchOrder" v-model="sortTime"
						 :placeholder="$t('other.a50')">
							<el-option v-for="item in options03" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</div> -->
				</div>
				<div>
					<el-table :data="pointsInfomation.data" height="400px" style="width: 100%">
						<!-- <el-table-column prop="ordersn" :label="$t('other.a59')" width="180">
							<template slot-scope="props">
								<span>{{transactionType(props.row)}}</span>
							</template>
						</el-table-column> -->
						<el-table-column prop="ordersn" :label="$t('other.a59')" width="180">
							<template slot-scope="props">
								<span>{{props.row.tradeDesc}}</span>
							</template>
						</el-table-column>
						<el-table-column :label="$t('other.a54')" width="180">
							<template slot-scope="props">
								<span>{{props.row.changeIntegral}}</span>
							</template>
						</el-table-column>
						<el-table-column :label="$t('other.a60')" width="180">
							<template slot-scope="props">
								<span>{{props.row.ordersn}}</span>
							</template>
						</el-table-column>

						<el-table-column :label="$t('other.a55')">
							<template slot-scope="props">
								<span>{{props.row.tradeState}}</span>
							</template>
						</el-table-column>
						<el-table-column  :label="$t('other.a61')">
							<template slot-scope="props">
								<span>{{getTime(props.row.createTime)}}</span>
							</template>
						</el-table-column>
						<el-table-column :label="$t('other.a62')">
							<template slot-scope="props">
								<span>{{props.row.totalIntegral}}</span>
							</template>
						</el-table-column>
					</el-table>
					<div style="width: 100%;display: flex;justify-content: flex-end;">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage4"
						 :page-sizes="[15, 30, 50, 100]" :page-size="15" layout="total, sizes, prev, pager, next, jumper" :total="pointsInfomation.count">
						</el-pagination>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="intergralPop=false">{{$t('other.a5')}} </el-button>

			</span>
		</el-dialog>

		<!-- 产品分类拣货 -->
		<el-dialog :title="$t('other.a63')" :visible.sync="bulletframecopy" @close="$emit('update:bulletframe',false)" width="70%">
			<div style="width: 100%;">
				<div style="margin-bottom: 10px;display: flex;justify-content: space-between;">
					<div>
						<el-select size="mini" v-model="skuSort" :placeholder="$t('other.a64')">
							<el-option v-for="item in options01" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</div>

					<div style="display: flex;">
						<el-input style="width: 300px;" size="mini" v-model="skusearch" :placeholder="$t('other.a65')" clearable></el-input>
						<el-button size="mini" type="primary" @click='searchSku'>{{$t('other.a27')}}</el-button>
					</div>

				</div>
				<el-table :data="categoryorderlist" height="350" ref="ridioTable" @current-change="handleSelectionChange01" style="width: 100%;">
					<el-table-column type="expand">
						<template slot-scope="props">
							<el-table :data="props.row.children" :show-header="false" ref="ridioTable" @current-change="handleSelectionChange01"
							 style="width: 100%">
								<el-table-column :label="$t('other.a29')" width="55">
									　　　　<template slot-scope="scope">
										　　　　　　<el-radio v-model="multipleSelection01" :label="scope.row"><i></i></el-radio>
										　　　　</template>
									　　</el-table-column>
								<el-table-column property="name" width="100">
									<template scope="scope">
										<el-popover placement="top-start" title="" trigger="hover">
											<img :src="scope.row.image" style="width: 150px;height: 150px" />
											<img slot="reference" :src="scope.row.image" style="width: 30px;height: 30px">
										</el-popover>
									</template>
								</el-table-column>
								<el-table-column property="cusCode" :show-overflow-tooltip="true"></el-table-column>
								<el-table-column property="variationId" :show-overflow-tooltip="true"></el-table-column>
								<el-table-column property="skuName" :show-overflow-tooltip="true"></el-table-column>
								<el-table-column property="shopId" :show-overflow-tooltip="true"></el-table-column>
								<el-table-column :show-overflow-tooltip="true">
									<template scope="scope">
										<span>{{scope.row.itemId}}</span>
									</template>
								</el-table-column>

							</el-table>

						</template>
					</el-table-column>
					<el-table-column :label="$t('other.a29')" width="55">
						　　　　<template slot-scope="scope">
							　　　　　　<el-radio v-model="multipleSelection01" :label="scope.row"><i></i></el-radio>
							　　　　</template>
						　　</el-table-column>
					<el-table-column property="name" :label="$t('other.a66')" width="100">
						<template scope="scope">
							<el-popover placement="top-start" title="" trigger="hover">
								<img :src="scope.row.main.image" style="width: 150px;height: 150px" />
								<img slot="reference" :src="scope.row.main.image" style="width: 60px;height: 60px">
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column property="main.cusCode" :label="$t('other.a67')" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column property="main.variationId" label="SKU" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column :label="$t('other.a68')" :show-overflow-tooltip="true">
						<template scope="scope">
							<span>{{scope.row.main.itemId}}</span>
						</template>
					</el-table-column>
					<el-table-column property="main.skuName" label="skuName" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column property="main.shopId" :label="$t('other.a69')" :show-overflow-tooltip="true"></el-table-column>

				</el-table>



			</div>




			<span slot="footer" class="dialog-footer">
				<div class="block">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage4"
					 :page-sizes="[15, 20, 30, 50]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="categoryordertotal">
					</el-pagination>
				</div>
				<div style="width: 100%;display: flex;justify-content: flex-end;">
					<el-button @click="submitSort" type="primary">{{$t('other.a38')}}</el-button>
				</div>

			</span>


		</el-dialog>
		<!-- 查看索赔的订单 -->
		<el-dialog :title="title_desc" :visible.sync="Claimpopupcopy" @close="$emit('update:claimpopup',false)" width="80%">
			<div style="width: 100%;">
				<span>{{$t('other.a70')}}</span>
				<el-select size="mini" v-model="storesvalue" @change="getClaimOrder" :placeholder="$t('other.a50')">
					<el-option v-for="item in Allstores" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				<span v-if="claimdatatype === 0" style="margin-left: 12px;">{{$t('other.a71')}}</span>
				<el-select v-if="claimdatatype === 0" size="mini" v-model="returnCasuevalue" @change="getClaimOrder" :placeholder="$t('other.a50')">
					<el-option v-for="item in returnCasue" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
				<el-button style="margin-left: 15px;color: orangered;" type="text" @click="exportExcel(0)">{{$t('other.a72')}}</el-button>
				<el-button style="margin-left: 15px;color: orangered;" type="text" @click="exportExcel(1)">{{$t('other.a73')}}</el-button>
				<el-button v-if="claimdatatype === 0" style="margin-left: 15px;color: orangered;" type="text" @click="fullClaim()">{{$t('other.a74')}}</el-button>
				<el-tooltip v-if="claimdatatype === 0" style="margin-left:20px"  effect="light" :content="$t('other.a75')" placement="bottom">
				<i class="el-icon-question" style="font-size:22px"></i>
				</el-tooltip>
				<el-table :data="claimlist" height="400px" @selection-change="handleSelectionChange">
					<el-table-column :label="$t('other.a29')" type="selection" width="55">
					</el-table-column>
					<el-table-column :label="$t('other.a60')">
						<template slot-scope="props">
							<span>{{props.row.orderId}}</span>
						</template>
					</el-table-column>
					<el-table-column :show-overflow-tooltip="true" width="120" :label="$t('other.a76')">
						<template slot-scope="props">
							<span>{{returnCause(props.row.returnCause)}}</span>
						</template>
					</el-table-column>
					<el-table-column :label="$t('other.a77')" width="120">
						<template slot-scope="props">
							<span>{{props.row.returnAmount}}</span>
						</template>
					</el-table-column>
					<el-table-column :label="$t('other.a78')" v-if="claimdatatype== 0 || claimdatatype==1" :show-overflow-tooltip="true">
						<template slot-scope="props">
							<span>{{getTime(props.row.createTime)}}</span>
						</template>
					</el-table-column>
					<el-table-column :label="$t('other.a79')" v-if="claimdatatype== 2 " :show-overflow-tooltip="true">
						<template slot-scope="props">
							<span>{{getTime(props.row.createTime)}}</span>
						</template>
					</el-table-column>
					<el-table-column :label="$t('other.a80')" :show-overflow-tooltip="true" v-if="claimdatatype== 0">
						<template slot-scope="props">
							<span style="color: red;">{{remainTime(props.row.createTime)}}</span>
						</template>
					</el-table-column>
					<el-table-column :show-overflow-tooltip="true" :label="$t('other.a33')">
						<template slot-scope="props">
							<span v-if="claimdatatype== 0" style="cursor: pointer;font-size:12px;color:#409EFF ;" @click="auditClaim(props.row)">{{$t('other.a81')}}</span>
							<!-- <span v-if="claimdatatype== 0 || claimdatatype== 1" style="cursor: pointer;font-size:12px;color:#409EFF ;padding-left: 15px;" @click="giveUp_Claim(props.row)">{{$t('other.a2270')}}</span> -->
							<span v-if="claimdatatype== 0" style="cursor: pointer;font-size:12px;color:#409EFF ;padding-left: 15px;" @click="viewLogistics01(props.row)">{{$t('other.a82')}}</span>
							<span v-if="claimdatatype== 1" style="cursor: pointer;font-size:12px;color:#409EFF ;padding-left: 15px;">{{$t('other.a83')}}</span>
							<span v-if="claimdatatype== 2" style="cursor: pointer;font-size:12px;color:#409EFF ;padding-left: 15px;color: red;">{{$t('other.a84')}}</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<span slot="footer" class="dialog-footer">
				<div class="block">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="1"
					 :page-sizes="[15, 20, 30, 50]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="claimlisttotal">
					</el-pagination>
				</div>
				<el-button type="primary" @click="Claimpopupcopy=false">{{$t('other.a5')}} </el-button>
			</span>
		</el-dialog>


		<!-- 查看物流 -->
		<el-dialog :title="$t('other.a85')" size="mini" :visible.sync="LogisticsWindowCopy" @close="$emit('update:LogisticsWindow',false)" width="60%">
			<div style="width: 100%;">
				<div class="logistics-header">
					<div style="padding: 5px 0;">{{$t('other.a86')}}{{LogisticsInfo.tracking_number}}</div>
					<div style="padding: 5px 0;">{{$t('other.a87')}}{{LogisticsInfo.order_sn}}</div>
				</div>
				<div style="padding: 5px 0;">{{$t('other.a88')}}{{returnCause(LogisticsInfo.logistics_status)}}</div>
				<el-table :data="LogisticsInfo.tracking_info" height="250px">
					<el-table-column :label="$t('other.a89')" width="200">
						<template slot-scope="scope">
							{{getLocalTime(scope.row.update_time)}}
						</template>
					</el-table-column>
					<el-table-column  :label="$t('other.a90')"  width="600">
						<template slot-scope="scope">
							{{scope.row.description}}
						</template>
					</el-table-column>

				</el-table>
			</div>


			<span slot="footer" class="dialog-footer">
				<el-button @click="LogisticsWindowCopy = false">{{$t('other.a5')}}</el-button>

			</span>
		</el-dialog>



		<!-- 填写收货信息 -->
		<el-dialog :title="$t('other.a91')" :visible.sync="receivingDialog" @close="$emit('update:openReceiveDialog',false)" width="30%">
			<div class="recevingBox">
				<div style="margin:10px 0">
					<span>{{$t('other.a92')}}</span>
					<el-select size="small" v-model="goodsOptionsValue" :disabled="!fixGoosType"  :placeholder="$t('other.a50')">
						<el-option
						v-for="item in goodsOptions"
						:key="item.value"
						:label="item.label"
						:value="item.value">
						</el-option>
					</el-select>
					<el-checkbox style="margin-left:10px" v-model="fixGoosType">{{$t('other.a93')}}</el-checkbox></el-checkbox>
				</div>
			
				<div class="edit-item">
					<label style="width: 80px">{{$t('other.a94')}}</label>
					<el-input style=" border: none !important" size="mini" v-model="length" :placeholder="$t('other.a95')"></el-input><label
					 style="width: 40px">cm</label>
				</div>
				<div class="edit-item">
					<label style="width: 80px">{{$t('other.a96')}}</label>
					<el-input size="mini" v-model="breadth" :placeholder="$t('other.a97')"></el-input><label style="width: 40px">cm</label>
				</div>
				<div class="edit-item">
					<label style="width: 80px">{{$t('other.a98')}}</label>
					<el-input size="mini" v-model="high" :placeholder="$t('other.a99')"></el-input><label style="width: 40px">cm</label>
				</div>
				<div class="edit-item">
					<label style="width: 80px">{{$t('other.a100')}}</label>
					<el-input size="mini" v-model="weight" :placeholder="$t('other.a101')"></el-input><label style="width: 40px">kg</label>
				</div>
				<div style="margin-top: 15px;">
					 <el-upload
					   class="upload-demo"
					   :headers="token"
					    action="https://erp.shopsbu.com/service/access/upload"
					   :on-remove="handleRemove"
					   :on-success="handlePreview"
					   list-type="picture">
					   <el-button size="small" type="primary">{{$t('other.a102')}}</el-button>
					   <div slot="tip" class="el-upload__tip">{{$t('other.a103')}}</div>
					 </el-upload>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="receivingDialog=false">{{$t('other.a5')}} </el-button>
				<el-button type="primary" @click="submitReceiveInfo()">{{$t('other.a38')}} </el-button>
			</span>
		</el-dialog>
	
	   <!-- 确认全部索赔弹框 -->
	   <el-dialog
	     :title="$t('other.a104')"
	     :visible.sync="dialogVisible"
	     width="30%"
	    >
	     <span style="color: red;">{{$t('other.a105')}}</span>
	     <span slot="footer" class="dialog-footer">
	       <el-button @click="dialogVisible = false">{{$t('other.a106')}}</el-button>
	       <el-button type="primary" @click="beginClaim">{{$t('other.a107')}}</el-button>
	     </span>
	   </el-dialog>
	   
	   <!-- 重新加载订单 -->
	   <el-dialog
	     :title="$t('other.a108')"
	     :visible.sync="reloadorderCope"
	     width="40%"
		 @close="$emit('update:reloadorder',false)"
	    >
		<div>
			<div>
				<label style="width: 80px;font-size: 18px;">{{$t('other.a109')}}</label>
				<el-select v-model="shopIdValue" :placeholder="$t('other.a50')">
				    <el-option
				      v-for="item in shopIdlist"
				      :key="item.value"
				      :label="item.label"
				      :value="item.value">
				    </el-option>
				  </el-select>
			</div>
				
			<div style="margin-top: 30px;">
				
				<label style="width: 80px;font-size: 18px;">{{$t('other.a110')}}</label>
				<el-input style="width: 250px;"   v-model="reloadOrdernum" :placeholder="$t('other.a111')"></el-input>
			</div>
		</div>
		
	     <span slot="footer" class="dialog-footer">
	       <el-button @click="reloadorderCope = false">{{$t('other.a106')}}</el-button>
	       <el-button type="primary" @click="loadOrder">{{$t('other.a112')}}</el-button>
	     </span>
	   </el-dialog>
	</div>
</template>

<script>
	import echarts from 'echarts'
	import utils from '../../utils/utils.js'
	import {
		mapState,
		mapActions,
		mapMutations
	} from 'vuex'
	export default {
		name: "Dialog",
		data() {
			return {
				addInputPop:[{
					value:'',
					id:1
				}],
				datalis: this.toComfirmClaimdata,
				choose: [],
				show: false,
				input10: '',
				page: 0,
				receivingDialog: false,
				caimtotal: 0,
				value3: true,
				Claimpopupcopy: this.Claimpopupdialog,
				textCount:'5',
				billviscopy: this.billvis,
				intergralPop:false,
				shopList: JSON.parse(localStorage.getItem('shopIdInfo')),
				pagesize: 15, //当前显示的数量15条
				multipleSelection: [],
				searchtext: '',
				value2: '',
				length: '',
				breadth: '',
				high: '',
				token:{
				token:JSON.parse(localStorage.getItem('userInfo')).token
				},
				flag:false,
				dialogVisible:false,
				currentPage4:1,
				weight: '',
				showAppDiaCopy:false,
				weanlyCopy:false,
				storesvalue: '',
				shopIdlist: [],
				bulletframecopy: this.bulletframe,
				skusearch: '',
				multipleSelection01: '',
				payorderstatus: '',
				sortTime: 5,
				returnCasuevalue: 0,
				returnCasue: [{
					value: 0,
					label: this.$t("other.a113")
				}, {
					value: 5,
					label: this.$t("other.a114")
				}, {
					value: 4,
					label: this.$t("other.a115")
				}, ],
				searchTime: [],
				options: [{
					value: -1,
					label: this.$t("other.a113")
				}, {
					value: 0,
					label: this.$t("other.a116")
				}, {
					value: 1,
					label: this.$t("other.a117")
				}],
				option01: [{
					value: '',
					label: this.$t("other.a113")
				}, {
					value: 0,
					label: this.$t("other.a118")
				}, {
					value: 1,
					label: this.$t("other.a119")
				}, {
					value: 2,
					label: this.$t("other.a120")
				}, {
					value: 3,
					label: this.$t("other.a121")
				}],
				options03: [{
					value: '',
					label: this.$t("other.a113")
				}, {
					value: 3,
					label: this.$t("other.a122")
				}, {
					value: 4,
					label: this.$t("other.a123")
				}, {
					value: 5,
					label: this.$t("other.a124")
				}, {
					value: 6,
					label: this.$t("other.a125")
				}],

				skuSort: 7,
				options01: [{
						value: 5,
						label: this.$t("other.a126")
					},
					{
						value: 6,
						label: this.$t("other.a127")
					},
					{
						value: 7,
						label: this.$t("other.a128")
					},
					{
						value: 8,
						label: this.$t("other.a129")
					}
				],
				goodsOptions: [],
				goodsOptionsValue:null,
				platform: -1,
				warehouseList: [],
				warehouseId: '',
				Allstores: [],
				fixGoosType:false,
				fileList:[],
				statusSort: false,
				In_stockDialog: this.instockdia,
				trackingDialog: this.tracking_Dialog,
				Acceptance: this.Acceptance_dialoag,
				pickerOptions2: {
					shortcuts: [{
						text: this.$t("other.a130"),
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: this.$t("other.a131"),
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: this.$t("other.a132"),
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
				value6: '',
				value7: '',
				chartsline: null,
				type: 1,
				imgUrls:'',
				reloadorderCope:this.reloadorder,
				reloadOrdernum:'',
				shopIdValue:null,
				LogisticsWindowCopy:false,
				customerDiaCopy:false,
			};
		},

		computed: {
			...mapState({
				userId: state => state.shopaccess.userInfo.userId,
				salesInfo: state => state.mygoods.salesInfo,
				intentoryturnover: state => state.mygoods.intentoryturnover,
				xuehuoInfo: state => state.userStoreItems.xuehuoInfo,
				storeSalesInfo: state => state.userStoreItems.storeSalesInfo,
				storeproductinventoryturnover: state => state.userStoreItems.storeproductinventoryturnover,
				storeoperaterecord: state => state.userStoreItems.storeoperaterecord,
				storeoperaterecordcount: state => state.userStoreItems.storeoperaterecordcount,
				printhistoryrecord: state => state.order.printhistoryrecord,
				printhistorycount: state => state.order.printhistorycount,
				payorderlist: state => state.recharge.payorderlist,
				payordercount: state => state.recharge.payordercount,
				categoryorderlist: state => state.order.categoryorderlist,
				toComfirmClaimdata: state => state.shopaccess.toComfirmClaimdata,
				toComfirmClaimtotal: state => state.shopaccess.toComfirmClaimtotal,
				Claimdata: state => state.shopaccess.Claimdata,
				Claimtotal: state => state.shopaccess.Claimtotal,
				hasClaimdata: state => state.shopaccess.hasClaimdata,
				hasClaimtotal: state => state.shopaccess.hasClaimtotal,
				claimlist: state => state.shopaccess.claimlist,
				claimlisttotal: state => state.shopaccess.claimlisttotal,
				categoryordertotal: state => state.order.categoryordertotal,
				LogisticsInfo: state => state.order.LogisticsInfo,
				exportXmlList: state => state.shopaccess.exportXmlList,
				pointsInfomation:state => state.recharge.pointsInfomation,
				goodsType: state => state.order.goodsType,
			}),

			title_desc() {
				if (this.claimdatatype == 0) {
					return this.$t("other.a133")
				} else if (this.claimdatatype === 1) {
					return this.$t("other.a134")
				} else if (this.claimdatatype === 2) {
					return this.$t("other.a135")
				}
			},
			printhistory() {
				if (this.show) {
					return this.choose
				} else {
					return this.printhistoryrecord
				}
			},
			printhistorycount01() {
				if (this.show) {
					return this.choose.length
				} else {
					return this.printhistorycount
				}
			},
			


		},
		props: {
			reloadorder:{
				type: Boolean,
				default: false
			},
			hideOverSea:{
				type: Boolean,
				default: false
			},
			LogisticsWindow:{
				type: Boolean,
				default: false
			},
			showAppDia:{
				type: Boolean,
				default: false
			},
			receiveItems:{
				type: Object,
				default: () => {}
			},
			intergralDia: {
				type: Boolean,
				default: false
			},
			productfenlei: {
				type: Object,
				default: () => {}
			},
			claimdatatype: {
				type: Number,
				default: 0
			},
			Claimpopup: {
				type: Boolean,
				default: false
			},
			weanly:{
				type: Boolean,
				default: false
			},
			billvis: {
				type: Boolean,
				default: false
			},
			instockdia: {
				type: Boolean,
				default: false
			},
			distributeText:{
				type: String,
				default ()
				{return this.$t("other.a136")}
				
			},
			tracking_Dialog: {
				type: Boolean,
				default: false
			},
			Acceptance_dialoag: {
				type: Boolean,
				default: false
			},
			AcceptancePackagedList: {
				type: Array,
				default: () => []
			},
			bulletframe: {
				type: Boolean,
				default: false
			},
			openReceiveDialog: {
				type: Boolean,
				default: false
			},
			customerDia: {
				type: Boolean,
				default: false
			},
			// Claimpopupdialog: {
			// 	type: Boolean,
			// 	default: false
			// }

		},
		watch: {

			customerDia(){
				this.customerDiaCopy=this.customerDia
			},
			reloadorder(){
				this.reloadorderCope=this.reloadorder
				if(this.reloadorder){
					this.shopIdlist=utils.getAllshop()
					console.log(this.shopIdlist)
				}
			},
			weanly(){
				this.weanlyCopy = this.weanly
			},
			LogisticsWindow(){
				this.LogisticsWindowCopy=this.LogisticsWindow
			},
			intergralDia(){
				this.intergralPop=this.intergralDia
			},
			exportXmlList() {
				if(this.flag){
					
				
				}else{
					
					this.exportXml()
					
				}
				
			},
			openReceiveDialog() {
				this.receivingDialog = this.openReceiveDialog
				if(this.receivingDialog){
					this.oop()
				}
			},
			Claimpopupcopy() {
				if (!this.Claimpopupcopy) {
					this.storesvalue = ''
					this.getshop()
					this.returnCasuevalue = 0,
						this.$emit('updataPage')
				}
			},
			Claimpopup() {
				this.Claimpopupcopy = this.Claimpopup

			},
			skusearch() {
				if (!this.skusearch) {
					console.log(111)
					this.handleCurrentChange()
				}
			},
			goodsType(){
				console.log('goodsType',this.goodsType)
				this.goodsOptionsValue=this.goodsType.goodsType
				this.goodsOptions=utils.getGoodsType()
				console.log('goodsOptions',this.goodsOptions)
			},

			bulletframe() {
				this.bulletframecopy = this.bulletframe
				if (!this.bulletframecopy) {
					this.page = 0
				}
			},
			bulletframecopy() {
				if (!this.bulletframecopy) {
					console.log(1235)
					this.skusearch = ''
				}
			},
			billvis() {
				this.billviscopy = this.billvis
			},
			Acceptance_dialoag() {
				this.Acceptance = this.Acceptance_dialoag
			},
			instockdia() {
				this.In_stockDialog = this.instockdia

			},

			showAppDia() {
				this.showAppDiaCopy = this.showAppDia

			},
			tracking_Dialog() {
				if (!this.tracking_Dialog) {
					this.input10 = ''
				}
				this.trackingDialog = this.tracking_Dialog
			},
			Acceptance() {
				if (!this.Acceptance) {
					this.value2 = ''
				}
			},
			searchtext() {
				if (!this.searchtext) {
					this.show = false
				}
			},
			claimlist(){
				
				this.currentPage4=1
			}

		},
		created() {
			// this.getPrinthistory()
			this.oop()
			// this.searchOrder()
			this.getshop()
		},
		inject: ['reload'],
		methods: {
			...mapActions('order', [
				'getPrintSheetHistory',
				'getPrintTogether',
				'getGoodsOrder',
				'getSpeciesOrder',
				'getStoreItem',
				'getShopAllItems',
				'viewLogistics',
				'fill_In_logisticsNumber',
				'reloadOrder'


			]),

			...mapActions('processed',[
				'setPackagedCopy',
				
			]),
			...mapActions('shopaccess', [
				'auditReturn',
				'giveUpClaim',
				'getReturnOrder'

			]),
			...mapActions('print', [
				'setPackaged',
				
			
			]),
			

			...mapActions('recharge', [
				'OrderTracking',
				'pointChange'

			]),

			...mapMutations('mygoods', [
				'GET_CURCODE_LIST_NULL',
				'SET_SUCCESS_ERROR_NULL',
			]),

			...mapMutations('order', [
				'GET_TTP',
				'GET_TTP_PPO'

			]),
			...mapMutations('shopaccess', [
				'DELET_HAS_CLAIM',

			]),
			
			loadOrder(){
				console.log(this.reloadOrdernum)
				console.log(this.shopIdValue)
				
				this.reloadOrder({
					orderId:this.reloadOrdernum,
					shopId:this.shopIdValue,
					userId:this.userId
				})
				this.reloadOrdernum=""
				this.shopIdValue=null
				this.reloadorderCope=false
			},
			
			addInputDia(num){
				if(num == 0){
					this.addInputPop.push({
						value:'',
						
					})
				}else{
					this.addInputPop.splice(num,1)
				}
				
			},
			//判断交易类型
			transactionType(item){
				if(item.isPay) {
					return this.$t("other.a137")
				}else if(item.isPay == null ){
					return this.$t("other.a138")
				}
			},

			//计算剩余索赔的有效时间
			remainTime(time) {
				return utils.cancelOrderTime(time, 30)
			},


			submitReceiveInfo() {
				if(!this.length || !this.high || !this.weight || !this.breadth){
					this.$message.warning(this.$t('other.a143'))
					return
				}
				let params = {
					goodsType:this.goodsOptionsValue,
					height:Number(this.high),
					length: Number(this.length),
					imgUrls:this.imgUrls ? this.imgUrls : '',
					orderId:this.receiveItems.orderId,
					shopId:this.receiveItems.shopId,
					storeId:this.receiveItems.storeId,
					userId: this.userId,
					weight: Number(this.weight),
					width:Number(this.breadth),	
				}
				
				console.log(params)
				this.fill_In_logisticsNumber(params)
				this.setPackagedCopy({orderId: this.receiveItems.orderId,userId:this.userId})
				this.receivingDialog=false
			},

			viewLogistics01(item) {
				console.log(item)
				let params = {
					ordersn: item.orderId,
					shopId: item.shopId
				}
				this.viewLogistics(params)
				this.LogisticsWindow = true
			},

			returnCause(ttp) {
				const status = {
					'LOST_PARCEL': this.$t("other.a114"),
					'LOGISTICS_DELIVERY_FAILED': this.$t("other.a115"),
					'Failed Delivery':this.$t("other.a115"),
					'LOST_PARCEL':this.$t("other.a114"),
					'Parcel lost in transit. The eligible compensation has been credited into your seller wallet.':this.$t("other.a114"),
					'LOGISTICS_ISSUE':this.$t("other.a139"),
					'Logistic Issue':this.$t("other.a139"),
					'Delivery service provider reported that the parcel has been lost.':this.$t("other.a114"),
					'FRAUD_CASE':'FRAUD_CASE',
					'':this.$t("other.a140"),
					
					
					
				}
				return status[ttp]
			},

			getClaimOrder() {
				this.shopIdlist = []
				if (!this.storesvalue) {
					this.Allstores.forEach(p => {
						if (p.value) {
							this.shopIdlist.push(p.value)
						}
					})
				} else {

					this.shopIdlist.push(this.storesvalue)

				}
				console.log(this.shopIdlist)
				let params = {}
				if (this.claimdatatype == 0) {
					params = {
						offset: 15,
						page: 0,
						shopIds: this.shopIdlist,
						type: this.returnCasuevalue,
						userId: this.userId,
					}
				} else if (this.claimdatatype == 1 || this.claimdatatype == 2) {
					params = {
						offset: 15,
						page: 0,
						shopIds: this.shopIdlist,
						type: this.claimdatatype,
						userId: this.userId,
					}
				}

				this.getReturnOrder(params)
			},


			getshop() {
				this.Allstores = utils.getAllshop()
				if(this.Allstores){
					this.Allstores.forEach(p => {
						if (p.value) {
							this.shopIdlist.push(p.value)
						}
					})
					
				}
			},
			giveUp_Claim(item) {
				console.log(item)
				this.$confirm(this.$t('other.a144'), this.$t("other.a142"), {
				  confirmButtonText: this.$t('other.a145'),
				  cancelButtonText: this.$t('other.a146'),
				  type: 'warning'
				}).then(() => {
					this.giveUpClaim({
						ordersn: item.orderId
					})
					
					
					
				})
				
			},

			// 索赔
			auditClaim(item) {
				console.log(item.orderId)
				// this.DELET_HAS_CLAIM(item.orderId)
				let arr=[]
				arr.push(item.orderId)
				this.auditReturn(arr)

			},
			oop() {
				this.searchTime[0] = utils.getchinastadarTime(-7)
				this.searchTime[1] = utils.getchinastadarTime(0)
				this.goodsOptions=utils.getGoodsType()
				console.log(this.goodsOptions)
			},

			getStatus(ttp) {
				const num = {
					0: this.$t('other.a147'),
					1: this.$t('other.a148')
				}
				return num[ttp]
			},

			payMethod(ttp) {
				const num = {
					0: this.$t('other.a149'),
					1: this.$t('other.a117')
				}
				return num[ttp]
			},
			getChinaTime(time) {
				let ttp = new Date(time)
				return ttp
			},
			searchOrder() {
				let params = null
				if (this.value3) { //按交易时间查找
					params = {
						platform: this.platform,
						orderStatus: this.payorderstatus,
						sortType: this.sortTime,
						gmtCreateSearchBeginTime: this.searchTime[0],
						gmtCreateSearchEndTime: this.searchTime[1],
						userId: this.userId,
					}
				} else { //按支付时间查找
					params = {
						platform: this.platform,
						orderStatus: this.payorderstatus,
						sortType: this.sortTime,
						timeEndSearchBeginTime: this.searchTime[0],
						timeEndSearchEndTime: this.searchTime[1],
						userId: this.userId,
					}
				}


				this.OrderTracking(params)
			},

			confrim01() {
				let obj = this.AcceptancePackagedList.filter(p => {
					if (p.trackingCode === this.value2) {
						return p
					}
				})
				console.log(this.AcceptancePackagedList)
				this.$emit('packBag', obj[0])
				this.Acceptance = false
			},

			confrim() {
				let array=this.addInputPop.map(p => p.value.replace(/\s+/g,""))
				 array.forEach((k,index) => {
					 if(k == '' || k==null || k == 'undefined'){
						 array.splice(index,1)
					 }
				 })
				
				 this.addInputPop.splice(1)
				 this.addInputPop[0].value=''
				 this.$emit('addtracking', array)
				 this.trackingDialog = false
			},

			printTogether() {
				console.log(this.multipleSelection)
				this.getPrintTogether({
					ids: this.multipleSelection
				})
			},
			setPeriod() {
				this.show = true
				let newArr = this.printhistoryrecord
				console.log(this.printhistoryrecord)
				let arr = []
				newArr.forEach(p => {
					let oop = p.ordersn
					oop.forEach(k => {
						if (k == this.searchtext) {
							arr.push(p)
						}
					})
				})
				console.log(arr)
				this.choose = arr
			},
			//查看历史打印的订单
			openHistory(url) {
				window.open(url)
			},

			getPrinthistory() {
				console.log(123)
				let params = {
					offset: this.offset,
					orderId: '',
					page: this.pagesize,
					shopIds: [],
					userId: this.userId,
				}
				this.getPrintSheetHistory(params)
			},

			getTime(time) {

				if (time == null) {
					return '--'
				}
				return utils.renderTime(time)
			},
			handleSizeChange(val) {
				this.pagesize = Number(`${val}`)
				console.log('每面显示的数量', this.pagesize);
				this.handleCurrentChange()
			},
			handleCurrentChange(val) {
				let num = Number(`${val}`)
				this.page = (num - 1) * this.pagesize


				if (this.billviscopy) { //验收代打包货物 
					let params = {}
					if (this.radio3) {
						params = {
							offset: this.pagesize,
							page: this.page,
							platform: this.platform,
							orderStatus: this.payorderstatus,
							sortType: this.sortTime,
							gmtCreateSearchBeginTime: this.searchTime[0],
							gmtCreateSearchEndTime: this.searchTime[1],
							userId: this.userId,
						}
					} else {
						params = {
							offset: this.pagesize,
							page: this.page,
							platform: this.platform,
							orderStatus: this.payorderstatus,
							sortType: this.sortTime,
							timeEndSearchBeginTime: this.searchTime[0],
							timeEndSearchEndTime: this.searchTime[1],
							userId: this.userId,
						}
					}


					this.OrderTracking(params)
					return
				}

				if (this.Claimpopupcopy) { //索赔订单的分页功能
					let params = {
						offset: this.pagesize,
						page: this.page,
						shopIds: this.shopIdlist,
						type: this.claimdatatype,
						userId: this.userId,
					}
					this.getReturnOrder(params)
					return
				}

				if (this.bulletframecopy) {
					this.getSpeciesOrder({
						shopId: this.productfenlei.shopId,
						type: this.productfenlei.type,
						userId: this.userId,
						offset: this.pagesize,
						page: this.page,

					})
					return
				}
				//积分扣减
				if (this.intergralPop) {
					this.pointChange({
						offset: this.pagesize,
						page: this.page,
						sortType:5,
						searchCreateBeginTime:utils.getchinastadarTime(-7),
						searchCreateEndTime:utils.getchinastadarTime(0),
						userId:this.userId,
					})
					return
				}
				
				

				console.log(this.shopList)
				let shoplist = this.shopList.map(p => {
					return p.shopId
				})

				let params = {
					offset: this.pagesize,
					orderId: '',
					page: this.page,
					shopIds: shoplist,
					userId: this.userId,
				}
				this.getPrintSheetHistory(params)
			},



			handleSelectionChange(val) {
		
				this.multipleSelection = val;
				console.log(this.multipleSelection)
			},

			handleSelectionChange01(val) {
				this.multipleSelection01 = val
				console.log(this.multipleSelection01)
				console.log(typeof(this.multipleSelection01))
			},


			searchSku() {
				console.log(this.skusearch)
				// const params={
				// 	offset:this.pagesize,
				// 	page:this.page,
				// 	userId:this.userId,
				// 	cusCode:this.skusearch
				// }
				const params = {
					offset: this.pagesize,
					page: this.page,
					userId: this.userId,
					type: this.type,
					itemName: this.skusearch
				}
				this.getShopAllItems(params)

			},

			submitSort() {
				this.statusSort = true
				console.log(this.multipleSelection01)
				if (!this.multipleSelection01) {
					this.$message.error(this.$t('other.a150'))
					return
				}

				this.getSpeciesOrder({
					shopId: this.productfenlei.shopId,
					type: this.productfenlei.type,
					userId: this.userId,
					offset: this.pagesize,
					page: this.page,

				})


				console.log(typeof(this.multipleSelection01))
				if (this.multipleSelection01.children) {
					if (this.multipleSelection01.main.cusCode == 0) {
						this.getGoodsOrder({
							itemId: Number(this.multipleSelection01.main.itemId),
							logisticsName: this.LogisticsValue,
							offset: 50,
							page: 0,
							skuId: Number(this.multipleSelection01.main.variationId),
							sortType: this.skuSort,
							type: this.productfenlei.type,

						})
					} else {
						this.getGoodsOrder({
							cusCode: Number(this.multipleSelection01.main.cusCode),
							logisticsName: this.LogisticsValue,
							offset: 50,
							page: 0,
							sortType: this.skuSort,
							type: this.productfenlei.type,

						})
					}

				} else {
					this.getGoodsOrder({
						itemId: Number(this.multipleSelection01.itemId),
						logisticsName: this.LogisticsValue,
						offset: 50,
						page: 0,
						skuId: Number(this.multipleSelection01.variationId),
						sortType: this.skuSort,
						type: this.productfenlei.type,
					})


				}

				this.bulletframecopy = false
				this.skusearch = ''
				this.skuSort = ''
			},

			goToDesc(){
				window.open('https://mp.weixin.qq.com/s/Y-HW4RqeVfEXW0OvLMNMfg')
			},

			getLocalTime(tiem) {
				//将时间戳（十三位时间搓，也就是带毫秒的时间搓）转换成时间格式
				// d.cTime = 1539083829787
				let ttp = parseInt(tiem) * 1000
				let date = new Date(ttp);
				let Y = date.getFullYear() + '-';
				let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
				let D = date.getDate() + ' ';
				let h = date.getHours() + ':';
				let m = date.getMinutes() + ':';
				let s = date.getSeconds();
				return Y + M + D + h + m + s;

				console.log(date)
			},
			handleRemove(file, fileList) {
							console.log(file, fileList);
							this.imgUrls=file.data
			 },
			 handlePreview(file) {
				console.log(file);
				this.imgUrls += file.data + ";"
				this.fileList.push({
					imageUrl:file.data
				})

				console.log('fileList',this.fileList)
				console.log('imgUrls',this.imgUrls)
			 },
			exportXml() {
				let arr = this.exportXmlList
				let csvlist = []
				arr.forEach(p => {
					csvlist.push(p)
				})
				let ttp = csvlist.map(p => {
					return {
						'订单号': p.orderId,
						'退货原因': p.returnCause,
						'金额': p.returnAmount,
						'下单时间': p.createTime,
					}

				})
				utils.exportExcel_Claim(ttp)
			},
			beginClaim(){//开始全部索赔
				console.log(this.exportXmlList)
			   
				let arr=this.exportXmlList.map(p =>p.orderId)
				console.log(arr)
				if(!arr.length) {
					this.$message.error(this.$t('other.a151'))
					return
				}
				this.auditReturn(arr)
				this.dialogVisible=false
			},
			fullClaim(){ //点击全部索赔，显示弹窗
				this.flag=true
				this.dialogVisible=true
				this.getReturnOrder({
							offset: this.claimlisttotal + 1,
							page: 0,
							shopIds: this.shopIdlist,
							type: this.returnCasuevalue,
							userId: this.userId,
							exportXml: 3
						})
			},

			exportExcel(num) {
				this.flag=false
				if (num === 1) {
					let params = {}
					if (this.claimdatatype == 0) {
						params = {
							offset: this.claimlisttotal + 1,
							page: 0,
							shopIds: this.shopIdlist,
							type: this.returnCasuevalue,
							userId: this.userId,
							exportXml: 3
						}
					}else if (this.claimdatatype == 1 || this.claimdatatype == 2) {
						params = {
							offset: this.claimlisttotal + 1,
							page: 0,
							shopIds: this.shopIdlist,
							type: this.claimdatatype,
							userId: this.userId,
							exportXml: 3
						}
					}
					this.getReturnOrder(params)
				}else{
					let arr = this.multipleSelection
					let csvlist = []
					if (!arr.length) {
						this.$message.error(this.$t('other.a152'))
						return
					}
					arr.forEach(p => {
						csvlist.push(p)
					})
					let ttp = csvlist.map(p => {
						return {
							'订单号': p.orderId,
							'退货原因': p.returnCause,
							'金额': p.returnAmount,
							'下单时间': p.createTime,
						}

					})
					utils.exportExcel_Claim(ttp)
				}
			},



		}
	}
</script>

<style>
	.edit-item {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		color: #9797a1;
		font-size: 14px;
		height: 40px;
		margin-top: 20px;
		border-bottom: 1px solid #e3e3e3
	}

	.ginkf{
		cursor: pointer;
		color:#409EFF;
		text-align: center;
	}

	.okgjbkd{
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		margin: 0 10px;
	}

	.owklgg{
		display: flex;
		justify-content: space-around;
	}

	.appimg{
		width: 145px;
		height: 145px;
		overflow: hidden;
	}

	.tesxt{
		font-size: 16px;
		margin-top: 10px;
	}



	.qrcode .el-dialog__body {
		padding: 10px 20px;
		color: #606266;
		font-size: 14px;
		word-break: break-all;
		display: flex;
		justify-content: center;
	}

	.recevingBox .el-input__inner {
		width: 150px !important;
		border: none !important;
	}
</style>
